import React from 'react';
import { REDUCED_CONTEXT_MSG } from '@components/Copilot/constants';
import { AgentId } from '@components/Copilot/types';
import { AvMessagePopover } from '@fabric-ui/components';
import { Prefix, X } from '@fabric-ui/icons';
import { InfoFullBlue, WarningFullOrange } from '@fabric-ui/icons/colorful';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box, Divider, IconButton, Typography, useTheme } from '@mui/material';
import { useAvCopilotContext } from '../../context/AvCopilotProvider';

const titleStyle = {
  background: theme => `linear-gradient(271deg, ${theme.palette.colors.primary[200]} -124.3%, #256CF7 141.48%)`,
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

const headerHeight = '56px';

interface ICopilotHeader {
  onClose: () => void;
  isReducedContextMode?: boolean;
}

const CopilotHeader: React.FC<ICopilotHeader> = ({ onClose, isReducedContextMode = false }) => {
  const theme = useTheme();
  const { lastSessionProps } = useAvCopilotContext();
  const isTicketAgent = lastSessionProps.agentId === AgentId.TICKET_AGENT;
  return (
    <Box sx={{ ...flex.colJustifyCenter, position: 'relative', height: headerHeight }}>
      <Box sx={{ ...flex.itemsCenter, gap: 1, pl: 3 }}>
        <Prefix style={iconSize(18)} fill={theme.palette.colors.primary[500]} />
        <Typography variant="h5" sx={titleStyle}>
          {isTicketAgent ? 'Remediation Copilot' : 'Copilot'}
        </Typography>
      </Box>
      <Box sx={{ ...flex.itemsCenter, gap: 1, position: 'absolute', right: 24 }}>
        <AvMessagePopover
          message={
            <Box sx={{ width: 285 }}>
              You have early access to {isTicketAgent ? 'Remediation Copilot' : 'Copilot'}. Please share feedback through our support
              channels.
            </Box>
          }
          includeIconInMessage
          icon={<InfoFullBlue />}
          asTooltip
        />
        {isReducedContextMode && (
          <AvMessagePopover
            message={<Box sx={{ width: 285 }}>{REDUCED_CONTEXT_MSG}</Box>}
            includeIconInMessage
            icon={<WarningFullOrange />}
            asTooltip
          />
        )}
        <Divider orientation="vertical" sx={{ height: 24, alignSelf: 'center' }} />
        <IconButton size="small" onClick={onClose}>
          <X style={{ width: 22, height: 22 }} />
        </IconButton>
      </Box>
    </Box>
  );
};

const MemoizedCopilotHeader = React.memo(CopilotHeader);

export default MemoizedCopilotHeader;
